// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.toolbar-panel[data-v-a8225d50] {\r\n    display: flex;\r\n    flex-direction: column;\n}\n.child-full[data-v-a8225d50] {\n}\n.child-half[data-v-a8225d50] {\r\n    display: flex;\r\n    flex-direction: row;\n}\n.ai-version[data-v-a8225d50] {\r\n    margin-left: 20px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
